export const NEXO_HMAC_KEY_LENGTH = 32;
export const NEXO_CIPHER_KEY_LENGTH = 32;
export const NEXO_IV_LENGTH = 16;
